<template>
  <el-container>
    <div class="header-menu">
      <el-row :gutter="24">
        <el-col :span="5">
          <img
            src="../assets/img/newLogo.png"
            @click="toHome"
            class="menu-logo"
          />
        </el-col>
        <el-col :span="15" class="header-bg" :offset="2">
          <ul>
            <li
              v-for="(items, index) in menuList"
              :key="index"
              :class="{ activeText: activeClass == index }"
              @click="handle(index)"
            >
              {{ items }}
            </li>
          </ul>
          <!-- <el-col :span="3">
            <div class="menu-tel">
              <span>|</span>
              <span>{{tel}}</span>
            </div>
          </el-col> -->
        </el-col>
      </el-row>
    </div>
  </el-container>
</template>

<script>
export default {
  name: "headerCom",
  props: {},
  data() {
    return {
      activeClass: 0,
      menuList: [
        "首页",
        "关于我们",
        // "业务介绍",
        // "新闻资讯",
        "人才招聘",
        // "信息披露",
        "联系我们",
        "应用介绍",
        /* ,
        "保险商城" */
      ],
      /*  tel: "0411-88891566", */
      homeActiveMenu: 0,
    };
  },
  components: {},
  watch: {
    $route(val) {
      let activeName = val.meta.title;
      for (let i in this.menuList) {
        if (this.menuList[i] == activeName) {
          this.activeClass = i;
          sessionStorage.setItem("activeClass", i);
        }
      }
    },
  },

  computed: {},
  created() {
    if (sessionStorage.getItem("activeClass")) {
      let index = sessionStorage.getItem("activeClass");
      this.activeClass = index;
    }
  },
  mounted() {
    window.onscroll = function () {
      let a = document.getElementsByClassName("header-menu")[0];
      a.style.left = "-" + document.documentElement.scrollLeft + "px";
    };
  },
  methods: {
    toHome() {
      this.activeClass = 0;
      sessionStorage.setItem("activeClass", 0);
      this.$router.push("/");
    },
    handle(index) {
      this.activeClass = index;
      sessionStorage.setItem("activeClass", index);
      this.getRouterPath(index);
      if (index == 8) {
        window.location.href = "#";
        this.$message("保险商城备案中敬请期待...");
        // window.open(''); // 跳页面
      }
    },
    // 获取当前路由，显示对应导航名字
    getRouterPath(index) {
      let activeRouter = this.$router.options.routes;
      for (let i in activeRouter) {
        //console.log(activeRouter[i])
        if (activeRouter[i].meta.title == this.menuList[index]) {
          if (this.$route.path !== activeRouter[i].path) {
            this.$router.push(activeRouter[i].path);
          }
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
body > .el-container {
  margin-bottom: 40px;
}
.header-menu {
  width: 100%;
  min-width: 1280px;
  box-sizing: border-box;
  background-color: rgba($color: #fff, $alpha: 0.85);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  .header-bg {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }

  .menu-logo {
    margin: 26px 0 0 42%;
    cursor: pointer;
  }
  .menu-tel {
    color: $font-color-gary1;
    font-size: $font-size-lv4;
    width: 135px;
  }
}
ul {
  display: flex;
  flex-wrap: nowrap;
  height: 58px;
  list-style-type: none;
  padding: 0px;
  margin: 38px 0 0 0;
}
li {
  color: $font-color-gary1;
  font-size: $font-size-lv4;
  float: left;
  width: 64px;
  margin-right: 30px;
  cursor: pointer;
  &:last-child {
    margin-right: 0px;
  }
}
.activeText {
  color: $font-color-main;
  font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue